/**
 * The call Mac and its transcription channel, provided app-wide by CallProvider, so leaf
 * components (dictation in any composer) can use the Mac whisper path without needing the
 * backend themselves. Absent (isolated renders): only on-device speech is offered.
 */
import type { CommandPayload } from '@viko/protocol'
import { createContext, useContext } from 'react'
import type { CallMac } from './mac.js'

export interface MacSpeech {
  mac: CallMac
  /** Send one sealed `call.audio` frame to the Mac; the last returns the transcript. */
  send(payload: CommandPayload<'call.audio'>): Promise<{ text?: string } | undefined>
}

export const CallMacContext = createContext<MacSpeech | undefined>(undefined)
export const useMacSpeech = () => useContext(CallMacContext)
